import React, { memo } from 'react'
import { useHistory } from 'react-router-dom'

import { makeStyles } from '@material-ui/core/styles'
import { DatePicker } from '@material-ui/pickers'
import Refresh from '@material-ui/icons/Refresh'

import Button from 'src/components/sharedComponents/CustomButtons/Button'
import CardTitle from 'src/components/sharedComponents/CardTitle'

import TotalEasyToHandleCompanyCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalEasyToHandleCompanyCard'
import TotalEasyToHandleByTerritoryCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalEasyToHandleByTerritoryCard'
import TotalEasyToDriverMopedCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalEasyToDriverMopedCard'
import TotalEasyToDriverSooterCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalEasyToDriverSooterCard'
import TotalEasyToResumGraphsCard from 'src/components/reports/reportsBoard/MarketShareReports/TotalEasyToResumGraphsCard'

const useStyles = makeStyles(() => ({
  root: {
    '& > *': {
      color: '#fff',
    },
  },
}))

const TotallyEasyToHandleByCompany = props => {
  const { selectedDate, handleDateChange } = props
  const classes = useStyles()
  const history = useHistory()

  return (
    <>
      <CardTitle
        title="Total fáciles de manejar por compañia"
        component={
          <DatePicker
            autoOk
            variant="inline"
            views={['year']}
            className={classes.root}
            value={selectedDate}
            maxDate={new Date()}
            onChange={handleDateChange}
          />
        }
      />
      <Button link onClick={() => history.push('/reports/board')}>
        <Refresh /> Volver al Menú
      </Button>
      <TotalEasyToHandleCompanyCard {...props} />
      <TotalEasyToHandleByTerritoryCard {...props} />
      <TotalEasyToDriverMopedCard {...props} />
      <TotalEasyToDriverSooterCard {...props} />
      <TotalEasyToResumGraphsCard
        titleCard="Comportamiento MOPED"
        arrayGA={props.gAMOPEDSubSegments}
        arrayGB={props.gBMOPEDSubSegments}
      />
      <TotalEasyToResumGraphsCard
        titleCard="Comportamiento SCOOTER"
        arrayGA={props.gAScooterSubSegments}
        arrayGB={props.gBScooterSubSegments}
      />
    </>
  )
}

export default memo(TotallyEasyToHandleByCompany)
